<div class="viewchart"> 
  <div class="charts-panel">
    <div class="col-sm-12 col-md-12 col-lg-12 charts-title">
      <div>
        <h2>
          <strong>
            {{ title | translate }}
          </strong>
          <small>
            <span *ngIf="caseDateStart.getDate() !== caseDateEnd.getDate()">
              {{ caseDateStart | date:'d' | translate }}
              {{
                (
                  caseDateStart.getMonth() === caseDateEnd.getMonth()
                  && caseDateStart.getFullYear() === caseDateEnd.getFullYear()
                )? null:caseDateStart | date:'MMMM' | translate
              }}
              {{
                caseDateStart.getFullYear() !== caseDateEnd.getFullYear()?
                caseDateStart.getFullYear():null
              }}
              {{ 'to' | translate }}
            </span>
            {{ caseDateEnd | date:'d' | translate }}
            {{ caseDateEnd | date:'MMMM' | translate }}
            {{
              caseDateStart.getFullYear() !== caseDateEnd.getFullYear()?
              caseDateEnd.getFullYear():null
            }}
          </small>
        </h2>
      </div>
      <div style="padding-top: 5px">
        <div class="calendar">
          <div
            class="input-group" daterangepicker options="dateoption"
            (selected)="setDateRange($event)">
            <button
              pButton type="button" class="btn btn-default btn-xs "
              icon="fa fa-calendar" iconPos="left"
              style="height: 30px; width: 30px;">
            </button>
          </div>
        </div>
        <app-casefilter
          [graph_id]="'survey'"
          (filter)="onFilters($event)">
        </app-casefilter>
        <button
          class="btn btn-success btn-sm" (click)="downloadCsv()"
          style="margin-left: 5px">
          <i class="fa fa-download fa-fw" aria-hidden="true"></i>
          {{ 'Download Report' | translate }}
        </button>
      </div>
    </div>
    <!--Answered Cases graph-->
    <div
      id="Answered_Cases" class="col-sm-6 col-md-4 col-lg-4 chart-panel"
      style="clear: both">
      <div class="card full-width">
        <div class="card-container">
          <h3>
            <a
              class="not-link"
              [routerLink]="['/admin/assistance/cases']"
              [queryParams]="{
                group_type: groupType,
                survey_evaluated: true,
                status: caseStatus.STATUS_CLOSE,
                from_date: filter.from_date,
                to_date: filter.to_date
              }">
              {{ 'Evaluations' | translate }}
            </a>
          </h3>
          <div class="select-chart">
            <a *ngIf="chartFormat[0]" (click)="selectFormat(0)">
              <i class="fa fa-pie-chart" aria-hidden="true"></i>
            </a>
            <a *ngIf="!chartFormat[0]" (click)="selectFormat(0)">
              <i class="fa fa-bar-chart" aria-hidden="true"></i>
            </a>
          </div>
          <p-chart
            *ngIf="!chartFormat[0]" type="pie" [data]="answeredCasesData"
            [options]="evaluationsOptions.pie" height="200">
          </p-chart>
          <p-chart
            *ngIf="chartFormat[0]" type="bar" [data]="answeredCasesData"
            [options]="evaluationsOptions.bar" height="200">
          </p-chart>
        </div>
      </div>
    </div>
    <!--Answered By graph-->
    <div id="Answered_By_User" class="col-sm-6 col-md-4 col-lg-4 chart-panel">
      <div class="card full-width">
        <div class="card-container">
          <h3>{{ 'Evuluators' | translate }}</h3>
          <div class="select-chart">
            <a *ngIf="chartFormat[1]" (click)="selectFormat(1)">
              <i class="fa fa-pie-chart" aria-hidden="true"></i>
            </a>
            <a *ngIf="!chartFormat[1]" (click)="selectFormat(1)">
              <i class="fa fa-bar-chart" aria-hidden="true"></i>
            </a>
          </div>
          <p-chart
            *ngIf="!chartFormat[1]" type="pie" [data]="answeredByData"
            [options]="graphOptions[0]" height="200">
          </p-chart>
          <p-chart
            *ngIf="chartFormat[1]" type="bar" [data]="answeredByData"
            [options]="graphOptions[1]" height="200">
          </p-chart>
        </div>
      </div>
    </div>

    <!--Points per Service-->
    <div id="Points_per_Service" class="col-sm-6 col-md-4 col-lg-4 chart-panel">
      <div class="card full-width">
        <div class="card-container">
          <h3>{{ 'Points per Service' | translate }}</h3>
          <div class="select-chart">
            <a *ngIf="chartFormat[3]" (click)="selectFormat(3)">
              <i class="fa fa-pie-chart" aria-hidden="true"></i>
            </a>
            <a *ngIf="!chartFormat[3]" (click)="selectFormat(3)">
              <i class="fa fa-bar-chart" aria-hidden="true"></i>
            </a>
          </div>
          <p-chart
            *ngIf="!chartFormat[3]" type="bar"
            [data]="pointsPerServiceData" [options]="graphOptions[5]"
            height="200">
          </p-chart>
          <p-chart
            *ngIf="chartFormat[3]" type="pie" [data]="pointsPerServiceData"
            [options]="graphOptions[4]" height="200">
          </p-chart>
        </div>
      </div>
    </div>

    <!--Average per Product-->
    <div
      id="Average_per_Product" class="col-sm-6 col-md-4 col-lg-4 chart-panel"
      style="clear: both">
      <div class="card full-width">
        <div class="card-container">
          <h3>{{ 'Average per Product' | translate }}</h3>
          <div class="select-chart">
            <a *ngIf="chartFormat[4]" (click)="selectFormat(4)">
              <i class="fa fa-pie-chart" aria-hidden="true"></i>
            </a>
            <a *ngIf="!chartFormat[4]" (click)="selectFormat(4)">
              <i class="fa fa-bar-chart" aria-hidden="true"></i>
            </a>
          </div>
          <p-chart
            *ngIf="!chartFormat[4]" type="bar"
            [data]="pointsPerProductData" [options]="graphOptions[5]"
            height="200">
          </p-chart>
          <p-chart
            *ngIf="chartFormat[4]" type="pie"
            [data]="pointsPerProductData" [options]="graphOptions[4]"
            height="200">
          </p-chart>
        </div>
      </div>
    </div>
    <!--Average per Country-->
    <div id="Average_per_Country" class="col-sm-6 col-md-4 col-lg-4 chart-panel">
      <div class="card full-width">
        <div class="card-container">
          <h3>{{ 'Average per Country' | translate }}</h3>
          <div class="select-chart">
            <a *ngIf="chartFormat[5]" (click)="selectFormat(5)">
              <i class="fa fa-pie-chart" aria-hidden="true"></i>
            </a>
            <a *ngIf="!chartFormat[5]" (click)="selectFormat(5)">
              <i class="fa fa-bar-chart" aria-hidden="true"></i>
            </a>
          </div>
          <p-chart
            *ngIf="!chartFormat[5]" type="bar"
            [data]="pointsPerCountryData" [options]="graphOptions[5]"
            height="200">
          </p-chart>
          <p-chart
            *ngIf="chartFormat[5]" type="pie"
            [data]="pointsPerCountryData" [options]="graphOptions[4]"
            height="200">
          </p-chart>
        </div>
      </div>
    </div>
    <!--Average per Sponsor-->
    <div id="Average_per_Sponsor" class="col-sm-6 col-md-4 col-lg-4 chart-panel">
      <div class="card full-width">
        <div class="card-container">
          <h3>{{ 'Average per Sponsor' | translate }}</h3>
          <div class="select-chart">
            <a *ngIf="chartFormat[6]" (click)="selectFormat(6)">
              <i class="fa fa-pie-chart" aria-hidden="true"></i>
            </a>
            <a *ngIf="!chartFormat[6]" (click)="selectFormat(6)">
              <i class="fa fa-bar-chart" aria-hidden="true"></i>
            </a>
          </div>
          <p-chart
            *ngIf="!chartFormat[6]" type="bar"
            [data]="pointsPerSponsorData" [options]="graphOptions[5]"
            height="200">
          </p-chart>
          <p-chart
            *ngIf="chartFormat[6]" type="pie"
            [data]="pointsPerSponsorData" [options]="graphOptions[4]"
            height="200">
          </p-chart>
        </div>
      </div>
    </div>

    <!--Average per Group graph-->
    <div id="Average_per_Group" class="col-sm-12 col-md-12 col-lg-12 chart-panel">
      <div class="card full-width">
        <div class="card-container">
          <h3>
            {{ 'Average per Section' | translate }}
            ({{totalAverageGroup}})
          </h3>
          <div class="select-chart">
            <a *ngIf="chartFormat[2]" (click)="selectFormat(2)">
              <i class="fa fa-bar-chart" aria-hidden="true"></i>
            </a>
            <a *ngIf="!chartFormat[2]" (click)="selectFormat(2)">
              <i class="fa fa-pie-chart" aria-hidden="true"></i>
            </a>
          </div>
          <p-chart
            *ngIf="!chartFormat[2]" type="bar"
            [data]="averagePerGroupData" [options]="graphOptions[3]"
            height="300">
          </p-chart>
          <p-chart
            *ngIf="chartFormat[2]" type="pie"
            [data]="averagePerGroupData" [options]="graphOptions[2]"
            height="300">
          </p-chart>
        </div>
      </div>
    </div>

    <!--Average per Case User graph-->
    <div
      id="Average_per_User_Evaluated"
      class="col-sm-12 col-md-12 col-lg-12 chart-panel">
      <div class="card full-width">
        <div class="card-container">
          <h3>
            {{ 'Average per User Evaluated' | translate }}
          </h3>
          <div class="select-chart">
            <a *ngIf="chartFormat[8]" (click)="selectFormat(8)">
              <i class="fa fa-bar-chart" aria-hidden="true"></i>
            </a>
            <a *ngIf="!chartFormat[8]" (click)="selectFormat(8)">
              <i class="fa fa-pie-chart" aria-hidden="true"></i>
            </a>
          </div>
          <p-chart
            *ngIf="!chartFormat[8]" type="bar"
            [data]="pointsPerCaseUser" [options]="userEvaluatedOptions.bar"
            height="200">
          </p-chart>
          <p-chart
            *ngIf="chartFormat[8]" type="pie"
            [data]="pointsPerCaseUser" [options]="userEvaluatedOptions.pie"
            height="300">
          </p-chart>
        </div>
      </div>
    </div>
  </div>
</div>
  
<!-- Download Report -->
<p-dialog
  [(visible)]="showDialogDownloadReport" [responsive]="true"
  [modal]="true" [draggable]="false"
  [breakpoint]="500" [blockScroll]="true">
  <ng-template pTemplate="header">
    {{ 'Download Report' | translate }}
  </ng-template>
  
  <form class="form-horizontal" (ngSubmit)="saveDownloadReport()">
    <div class="form-group">
      <label class="control-label col-sm-2">{{ 'File Type' | translate }}:</label>
      <div class="col-sm-10">
        <select
          class="form-control" [(ngModel)]="downloadReport.file_type"
          name="file_type">
          <option value="csv">CSV</option>
          <option value="xlsx">XLSX</option>
        </select>
      </div>
    </div>
    <div class="form-group">
      <div class="col-sm-offset-2 col-sm-10">
        <button
          type="button" class="btn btn-default btn-sm btn-right"
          (click)="onDownloadCancel()">
          {{ 'Cancel' | translate }}
        </button>
        <button
          type="submit" class="btn btn-primary btn-sm btn-right">
          {{ 'Save' | translate }}
        </button>
      </div>
    </div>
  </form>
</p-dialog>
  